export const paymentMethods = {
  CASH: 'CASH',
  CARD: 'CARD',
  BANK: 'BANK',
  AUCTION: 'AUCTION',
  BALANCE: 'BALANCE',
}
